export default {
    /* GET_PAPERS
    ---------------------------------------------------------------
    */
    GET_PAPERS_REQUEST: state => {
        state.papersLoading = true
    },
    GET_PAPERS_SUCCESS: (state, data) => {
        state.papers = data.results
        state.papersLoading = false
    },
    GET_PAPERS_FAILURE: state => {
        state.papersLoading = false
    },
    GET_CERTIFICATES_REQUEST: state => {
        state.certificatesLoading = true
    },
    GET_CERTIFICATES_SUCCESS: (state, data) => {
        state.certificates = data.results
        state.certificatesLoading = false
    },
    GET_CERTIFICATES_FAILURE: state => {
        state.certificatesLoading = false
    },
    GET_COATING_TYPES: (state, data) => {
        state.coatingTypes = data.results
    },
    GET_PRINERGY_PAPER_TYPES: (state, data) => {
        state.prinergyPaperTypes = data.results
    },
    SET_PAPERS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_PAPERS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    },
    SET_CANCEL_TOKEN: (state, token) => {
        state.cancelToken = token
    }
}